// client/src/routes/_auth/login.tsx — SCR-AUTH-001 „Autentificare" · AUTH-004.

import { createFileRoute, redirect } from '@tanstack/react-router';

import { LoginForm } from '@/features/auth/LoginForm';
import { landingFor, redirectSearchSchema, safeRedirect } from '@/features/auth/redirect';
import { ensureSession } from '@/session';

export const Route = createFileRoute('/_auth/login')({
  validateSearch: redirectSearchSchema,
  // A visitor who already holds a session has nothing to do here; the deep link they carried
  // is honoured the same way it would have been after a login.
  beforeLoad: async ({ search }) => {
    const session = await ensureSession();
    if (session) throw redirect({ href: safeRedirect(search.redirect, landingFor(session)) });
  },
  component: LoginScreen,
});

function LoginScreen() {
  const search = Route.useSearch();
  return <LoginForm search={search} />;
}
